import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

declare let Wistia: any;

@Component({
    standalone: false,
    selector: 'core-block-cloud-reasontiles',
    templateUrl: './block-cloud-reasontiles.component.html',
})

export class BlockCloudReasontilesComponent extends BlockAbstractComponent implements OnInit {

    override ngOnInit() {
        super.ngOnInit();
    }

    parseImagePath(blockImagePath: string): string {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            return 'https://benefits.paloaltonetworks.com' + blockImagePath;
        } else {
            return blockImagePath;
        }
    }

    parseImagePathURL(blockImagePath: string): string {
        if (window.location.host === 'cloudacademy.paloaltonetworks.com') {
            return 'url(https://benefits.paloaltonetworks.com' + blockImagePath + ')';
        } else {
            return 'url(' + blockImagePath + ')';
        }
    }

    playVideo() {
        const wistiaObj = Wistia.api('3rckh4rnv7');
        if (wistiaObj) {
            wistiaObj.play();
        }
    }
}
